import React, { useEffect } from "react";
import successSound from "../assets/sounds/succes.mp3";

const SuccessNotification = React.memo(({ title, description, onClose }) => {
  useEffect(() => {
    const audio = new Audio(successSound);
    audio.play();
  }, []);

  return (
    <div className="fixed bottom-4 right-4 bg-green-500 text-white p-4 rounded-lg shadow-lg w-80 animate-slide-in">
      <h3 className="text-lg font-bold mb-2">{title}</h3>
      <p className="text-sm">{description}</p>
      <button
        onClick={onClose}
        className="mt-4 bg-green-700 text-white px-4 py-2 rounded-md hover:bg-green-800 transition"
      >
        Fermer
      </button>
    </div>
  );
});

export default SuccessNotification;
